// import React from "react";
import React, { useEffect } from "react";
import {
  ArrowLeft,
  ShieldCheck,
  Lock,
  Database,
  Globe,
  Users,
  Cookie,
  Laptop,
  Mail,
  FileText,
  Scale,
  RefreshCw,
  Phone,
} from "lucide-react";
import { useNavigate } from "react-router-dom";

const PrivacyPolicy = () => {
  const navigate = useNavigate();

  useEffect(() => {
  window.scrollTo({
    top: 0,
    left: 0,
    behavior: "instant",
  });
}, []);

  const sections = [
    {
      icon: <Database size={22} />,
      title: "What & Why",
      content:
        "We collect and use the following information to provide, improve, protect, and promote our Services. ",
    },
    {
      icon: <Users size={22} />,
      title: "Account Information",
      content:
        "We collect, and associate with your account, the information you provide to us when you do things such as sign up for your account, upgrade to a paid plan, and set up two-factor authentication (like your name, email address, phone number, payment info, and physical address). ",
    },
    {
      icon: <FileText size={22} />,
      title: "Your Stuff",
      content:
        'You may choose to give us access to your contacts to make it easy for you, and your Drivault Team if you are a Drivault Team user, to do things like share and collaborate on Your Stuff, send messages, and invite others to use the Services. If you do, we will store those contacts on our servers. ',
    },
    {
      icon: <Users size={22} />,
      title: "Contacts",
      content:
        "You may choose to provide access to your contacts to make sharing, collaboration, and invitations easier. If enabled, those contacts may be securely stored on our servers.",
    },
    {
      icon: <FileText size={22} />,
      title: "Usage Information",
      content:
        "We collect information related to how you use the Services, including actions you take in your account (like sharing, editing, viewing, creating and moving files or folders, and sending and receiving electronic signature requests and other transactions). We use this information to provide, improve, and promote our Services, and protect Drivault users. Please refer to our FAQ for more information about how we use this usage information. "    },
    {
      icon: <Laptop size={22} />,
      title: "Device Information",
      content:
                "We also collect information from and about the devices you use to access the Services. This includes things like IP addresses, the type of browser and device you use, the web page you visited before coming to our sites, and identifiers associated with your devices. Your devices (depending on their settings) may also transmit location information to the Services. For example, we use device information to detect abuse and identify and troubleshoot bugs."    },
    {
      icon: <Cookie size={22} />,
      title: "Cookies & Technologies",
      content:
        "We use technologies like cookies and pixel tags to provide, improve, protect, and promote our Services. For example, cookies help us with things like remembering your username for your next visit, understanding how you are interacting with our Services, and improving them based on that information. You can set your browser to not accept cookies, but this may limit your ability to use the Services. If our systems receive a DNT:1 signal from your browser, we will respond to that signal as outlined in our FAQ. We may also use third-party service providers that set cookies and similar technologies to promote Drivault services. "
        },

        {
      icon: <Database size={22} />,
      title: "Recipient and Viewer Analytics ",
      content:
    "When you view content included in portions of our Services that provide analytics to content owners, we collect information including your identifying and device information, such as email addresses, IP addresses, and device identifiers of devices you use to view the content. We also collect information on how you interact with the viewed content, such as the date and time you view the content, the number of times and length of time you view the content, and which portions of the content you view. ",
    },

    {
      icon: <Mail size={22} />,
      title: "Marketing",
      content:
        "We give users the option to use some of our Services free of charge. These free Services are made possible by the fact that some users upgrade to one of our paid Services. If you register for our Services, we will, from time to time, send you information about upgrades when permissible. Users who receive these marketing materials can opt out at any time. If you do not want to receive a particular type of marketing material from us, click the 'unsubscribe' link in the corresponding emails, or update your preferences in the Notifications section of your personal account. We may also collect information from you if you interact with Drivault representatives at an event, download marketing or educational materials from our website, or contact a Drivault representative. We may use the information you provide to send you additional marketing materials. We sometimes contact people who do not have a Drivault account. For recipients in the EU, we or a third party will obtain consent before reaching out. If you receive an email and no longer wish to be contacted by Drivault, you can unsubscribe and remove yourself from our contact list via the message itself. "    },
    {
      icon: <Scale size={22} />,
      title: "Bases for Processing Data",
      content:
        "We collect and use the personal data described above in order to provide you with the Services in a reliable and secure manner. We also collect and use personal data for our legitimate business needs. To the extent we process your personal data for other purposes, we ask for your consent in advance or require that our partners obtain such consent. For more information on the lawful bases for processing your data, the categories of personal information included, and how we use artificial intelligence and machine learning, please see our FAQ. "
    },
    {
      icon: <Users size={22} />,
      title: "With Whom",
      content:
        "We may share information as discussed below, but we will not sell it to advertisers or other third parties"
    },
{
    icon: <Database size={22} />,
      title: "Others Working for and with Drivault",
      content:
    "Drivault uses certain trusted third parties (for example, providers of customer support and IT services) for the business purposes of helping us provide, improve, protect, and promote our Services. These third parties will access your information to perform tasks on our behalf, and we will remain responsible for their handling of your information per our instructions. For a list of categories of trusted third parties that we use to process your personal data, please see our FAQ"
},

{
    icon: <Database size={22} />,
      title: "Other Drivault Companies",
      content:
        "Drivault shares infrastructure, systems, and technology with other Drivault group companies to provide, improve, protect, and promote Drivault Services. We process your information across the Drivault group for these purposes, as permitted by applicable law and in accordance with their terms and policies. "
},

{
    icon: <Database size={22} />,
      title: "Other Users ",
      content:
        "Our Services are designed to help you collaborate with others. If you register your Drivault account with an email address on a domain owned by your employer or organization, join a Drivault Team, or collaborate with other Drivault users, we may suggest you or your team as a potential collaborator to other users or teams. Collaborators and potential collaborators may see some of your basic information, like your name, Drivault Team name, profile picture, device, email address, and usage information. Certain features let you make additional information available to others. For example, if you view a file or folder shared from a feature that provides recipient or viewer analytics to content owners, we will share your identifying information such as name and email address, information on the device you used to view the content, and for how long you viewed content and what portion of the content you viewed with the owner of the file or folder. "
},

{
      icon: <Globe size={22} />,
      title: "Other Applications ",
      content:
        "You can choose to connect your Drivault account with third-party services via Drivault APIs. By doing so, you are enabling Drivault and those third parties to exchange information about you and data in your account so that Drivault and those third parties can provide, improve, protect, and promote their services. Third parties' use of your information will be governed by their own privacy policies and terms of service. "
    },

      {
  icon: <Users size={22} />,
  title: "Team Admins",
  content:
    "If you are a user of a Drivault Team, your administrator may have the ability to access and control your Drivault Team account. Please refer to your organization’s internal policies if you have questions about this. If you are not a Drivault Team user but interact with a Drivault Team user — for example, by joining a shared folder or accessing content shared by that user — members of that organization may be able to view information about you such as your name, email address, profile picture, and your interaction with the Drivault Team user.",
},

{
  icon: <ShieldCheck size={22} />,
  title: "Law & Order and the Public Interest",
  content: (
    <div className="space-y-6">
      <p>
        We may disclose your information to third parties if
        we determine that such disclosure is reasonably
        necessary to:
      </p>

      <ul className="list-disc pl-6 space-y-3">
        <li>
          Comply with any applicable law, regulation,
          legal process, or appropriate government request.
        </li>

        <li>
          Protect any person from death or serious bodily
          injury.
        </li>

        <li>
          Prevent fraud or abuse of Drivault or our users.
        </li>

        <li>
          Protect Drivault’s rights, property, safety,
          or interests.
        </li>

        <li>
          Perform a task carried out in the public
          interest.
        </li>
      </ul>

      <p>
        Stewardship of your data is critical to us and a
        responsibility that we embrace. We believe your
        data should receive the same legal protections
        regardless of whether it is stored on our
        Services or on your own device.
      </p>

      <p>
        We abide by the following Government Request
        Principles when receiving, scrutinizing, and
        responding to government requests for your data:
      </p>

      <div className="grid sm:grid-cols-2 gap-4">

       <ul className="list-disc pl-6 space-y-3">
        <li>
         Be Transparent
        </li>

        <li>
          Fight Blanket Requests
        </li>

        <li>
          Protect All Users
        </li>

        <li>
          Provide Trusted Services
        </li>

       
      </ul>

      </div>

      <p>
        We publish a Transparency Report as part of our
        commitment to informing you about when and how
        governments ask us for information. We encourage
        you to review our Government Request Principles
        and Transparency Report for more detailed
        information on our approach and response to
        government requests.
      </p>
    </div>
    ),
    },
   
    {
      icon: <Lock size={22} />,
      title: "Security",
      content:
        "We have a team dedicated to keeping your information secure and testing for vulnerabilities. We continue to work on features to keep your information safe in addition to things like two-factor authentication, encryption of files at rest, and alerts when new devices and apps are linked to your account. We deploy automated technologies to detect abusive behavior and content that may harm our Services, you, or other users. "
    },
    {
      icon: <RefreshCw size={22} />,
      title: "Retention",
      content:
        "When you sign up for an account with us, we will retain information you store on our Services for as long as your account exists or as long as we need it to provide you the Services. If you delete your account, we will initiate deletion of this information after 30 days. Please note: (1) there might be some latency in deleting this information from our servers and back-up storage; and (2) we may retain this information if necessary to comply with our legal obligations, resolve disputes, or enforce our agreements."
    },
    {
      icon: <Globe size={22} />,
      title: "Around the World",
      content:
    "When you sign up for an account with us, we will retain information you store on our Services for as long as your account exists or as long as we need it to provide you the Services. If you delete your account, we will initiate deletion of this information after 30 days. Please note: (1) there might be some latency in deleting this information from our servers and back-up storage; and (2) we may retain this information if necessary to comply with our legal obligations, resolve disputes, or enforce our agreements."
    },

     {
      icon: <RefreshCw size={22} />,
      title: "Data Transfers",
      content:
    "When transferring data across international boundaries, Drivault relies upon a variety of legal mechanisms, such as contracts with our customers and affiliates, Standard Contractual Clauses, and applicable adequacy decisions, as required by applicable law. "
    },

    {
  icon: <ShieldCheck size={22} />,
  title: "Your Control and Access of Your Data",
  content: (
    <div className="space-y-6">
      <p>
        You have control over your personal data and how it
        is collected, used, and shared. For example, you can:
      </p>

      <ul className="list-disc pl-6 space-y-3">
        <li>
          Delete Your Stuff in your Drivault account.
        </li>

        <li>
          Change or correct personal data through your
          account settings page.
        </li>

        <li>
          Access and take your data elsewhere — you can
          access your personal data from your Drivault
          account and download a copy of Your Stuff in a
          machine-readable format.
        </li>

        <li>
          Object to the processing of your personal data —
          depending on the processing activity, you can
          request that we stop or limit processing of your
          personal data.
        </li>
      </ul>

      <p>
        You can submit a data access request or request
        that your personal data be deleted by contacting
        us at{" "}
        <span className="text-[#40E095] font-medium">
          support@drivault.com
        </span>.
      </p>

      <p>
        For more information on how to control and access
        your personal data, please see our FAQ.
      </p>
    </div>
  ),
},
    {
      icon: <RefreshCw size={22} />,
      title: "Changes to This Policy",
      content:
    "If we are involved in a reorganization, merger, acquisition, or sale of our assets, your data may be transferred as part of that deal. We will notify you (for example, via a message to the email address associated with your account) of any such deal and outline your choices in that event. We may revise this Privacy Policy from time to time, and will post the most current version on our website. If a revision meaningfully reduces your rights, we will notify you."    },
  ];

  

  return (
    <div className="min-h-screen bg-[#F6F9FC] text-[#0F172A] overflow-hidden">
      {/* Background Effects */}
      <div className="absolute top-0 left-0 w-full h-[400px] bg-gradient-to-b from-[#40E095]/10 via-[#40E095]/5 to-transparent pointer-events-none" />

      <div className="absolute top-40 right-[0px] w-[350px] h-[350px] bg-[#40E095]/10 blur-3xl rounded-full pointer-events-none" />

      <div className="absolute bottom-0 left-[-120px] w-[350px] h-[350px] bg-emerald-200/20 blur-3xl rounded-full pointer-events-none" />

      <div className="relative max-w-6xl mx-auto px-6 py-14">
        {/* Back Button */}
      <button
  onClick={() => {
    navigate("/");

    setTimeout(() => {
      window.scrollTo({
        top: 0,
        behavior: "instant",
      });
    }, 0);
  }}
  className="flex items-center gap-2 text-gray-500 hover:text-[#40E095] transition-all duration-300 mb-10"
>
  <ArrowLeft size={20} />
  <span className="font-medium">Back</span>
</button>

        {/* HERO SECTION */}
       <div className="relative bg-white/90 backdrop-blur-xl border border-white shadow-[0_10px_40px_rgba(0,0,0,0.05)] rounded-[28px] overflow-hidden mb-6">
  
  <div className="absolute top-0 right-0 w-[180px] h-[180px] bg-[#40E095]/10 blur-3xl rounded-full" />

  <div className="relative p-5 md:p-8">

    <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-6">
      
      {/* Left */}
      <div className="max-w-3xl">

        <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900 leading-tight">
          Privacy{" "}
          <span className="text-[#40E095]">
            Policy
          </span>
        </h1>

        <p className="mt-4 text-base md:text-lg text-slate-600 leading-7 max-w-3xl">
          Thanks for using Drivault. This Privacy Policy explains
          how we collect, use, store, process, and protect your
          personal information when you use our websites,
          applications, and cloud storage services.
        </p>

        <div className="grid sm:grid-cols-2 gap-4 mt-6">

          <div className="bg-[#F8FAFC] border border-slate-200 rounded-2xl p-4">
            <p className="text-xs text-slate-500 mb-1">
              Posted
            </p>

            <p className="font-semibold text-base">
              May 9, 2026
            </p>
          </div>

          <div className="bg-[#F8FAFC] border border-slate-200 rounded-2xl p-4">
            <p className="text-xs text-slate-500 mb-1">
              Effective
            </p>

            <p className="font-semibold text-base">
              May 9, 2026
            </p>
          </div>

        </div>
      </div>

      {/* Right Card */}
      <div className="w-full lg:max-w-[320px]">

        <div className="bg-[#0F172A] text-white rounded-3xl p-6 shadow-xl relative overflow-hidden">

          <div className="absolute top-0 right-0 w-28 h-28 bg-[#40E095]/20 blur-3xl rounded-full" />

          <div className="relative">

            <div className="w-14 h-14 rounded-2xl bg-[#40E095]/15 border border-[#40E095]/30 flex items-center justify-center mb-4">
              <ShieldCheck
                size={28}
                className="text-[#40E095]"
              />
            </div>

            <h3 className="text-xl font-bold mb-3">
              Drivault
            </h3>

            <div className="space-y-3 text-slate-300 leading-6 text-sm">

              <p>
                Outofbox Cloud Private Limited
              </p>

              <p>
                4th Floor, Oneness,
                Sadashivnagar, Belagavi,
                Karnataka, India 590001
              </p>

              <div className="pt-3 border-t border-white/10">

                <div className="flex items-center gap-2 mb-2">
                  <Phone size={15} />
                  <span>6363-900-800</span>
                </div>

                <div className="flex items-center gap-2">
                  <Mail size={15} />
                  <span className="break-all">
                    support@drivault.com
                  </span>
                </div>

              </div>
            </div>

          </div>
        </div>
      </div>

    </div>
  </div>
</div>

        {/* CONTENT */}
        <div className="grid gap-8">
          {sections.map((section, index) => (
            <div
              key={index}
              className="group bg-white/90 backdrop-blur-xl border border-white shadow-[0_10px_50px_rgba(0,0,0,0.05)] hover:shadow-[0_20px_60px_rgba(64,224,149,0.12)] transition-all duration-500 rounded-[28px] p-8 md:p-10"
            >
              <div className="flex items-start gap-5">
                <div className="min-w-[60px] w-[60px] h-[60px] rounded-2xl bg-[#40E095]/10 border border-[#40E095]/20 flex items-center justify-center text-[#40E095] group-hover:scale-110 transition-transform duration-300">
                  {section.icon}
                </div>

                <div>
                  <h2 className="text-2xl md:text-3xl font-bold mb-4 tracking-tight">
                    {section.title}
                  </h2>

                  <p className="text-slate-600 leading-7 text-[17px]">
                    {section.content}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* FOOTER */}
       <div className="mt-10 bg-gradient-to-r from-[#0F172A] to-[#111827] rounded-[28px] p-7 md:p-10 text-white relative overflow-hidden">
  
  <div className="absolute top-0 right-0 w-[220px] h-[220px] bg-[#40E095]/20 blur-3xl rounded-full" />

  <div className="relative z-10">

    <div className="flex items-center gap-3 mb-4">
      <ShieldCheck
        className="text-[#40E095]"
        size={28}
      />

      <h2 className="text-2xl md:text-3xl font-bold">
        Contact Us
      </h2>
    </div>

    <p className="text-slate-300 text-base leading-7 max-w-3xl">
      If you have any questions, concerns, or requests
      regarding this Privacy Policy or your personal data,
      please contact the Drivault support team.
    </p>

    <div className="grid md:grid-cols-2 gap-4 mt-7">

      <div className="bg-white/5 border border-white/10 rounded-2xl p-5">
        <p className="text-slate-400 text-sm mb-1">
          Customer Care
        </p>

        <p className="text-lg font-semibold">
          6363-900-800
        </p>
      </div>

      <div className="bg-white/5 border border-white/10 rounded-2xl p-5">
        <p className="text-slate-400 text-sm mb-1">
          Email Address
        </p>

        <p className="text-lg font-semibold break-all">
          support@drivault.com
        </p>
      </div>

    </div>

    <div className="mt-7 pt-5 border-t border-white/10 text-slate-400 text-sm">
      © 2026 Drivault — Outofbox Cloud Private Limited.
      All rights reserved.
    </div>

  </div>
</div>
        
      </div>
    </div>
  );
};

export default PrivacyPolicy;